// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5a1b847e","453":"14e853f9","732":"3288a24b","977":"e0616656"}[chunkId] + ".chunk.js";
};